import React, {useCallback} from 'react';
import PropTypes from 'prop-types';
import SMCTextInput from '../SMCTextInput';

/**
 * 
 * @param {object} params
 * @param {boolean} params.disabled
 * @param {boolean} params.readOnly
 * @param {(string|number)} params.value
 * @param {function} params.onChange
 * @param {string} params.className
 * @param {string} params.label
 * @param {('start'|'end')} params.labelPosition
 * @param {(string|number)} params.labelWidth
 * @param {string} params.tooltip
 * @param {boolean} params.inline
 * @param {boolean} params.noAutoComplete
 * @param {object} params.style
 * @param {string} params.placeholder
 * @param {(string|number)} params.height
 * @param {*} params.innerRef
 * @param {(string|number)} params.width
 * @param {boolean} params.allowClearAll
 * @param {string} params.suffixIcon
 * @param {boolean} params.required
 * @param {boolean} params.ignoreDisabledContext
 * @param {boolean} params.noNegative
 */
function SMCNumberInput({
    placeholder,
    disabled,
    noAutoComplete,
    readOnly,
    width,
    value,
    onChange,
    className,
    style,
    allowClearAll,
    height,
    inline,
    label,
    labelPosition,
    labelWidth,
    suffixIcon,
    suffixIconOnClick,
    tooltip,
    innerRef,
    required,
    ignoreDisabledContext,
    noNegative,
    // minimum,
    // maximum,
    ...rest
}) {
    let displayValue;
    if (typeof value === 'undefined') {
        displayValue = undefined;
    } else {
        try {
            displayValue = parseInt(value);
        } catch (err) {
            displayValue = null;
        }
    }

    const _onChange = useCallback(e => {
        if (noNegative && e.target.value && e.target.value.indexOf('-') === 0) {
            return;
        }
        // if ((hasValue(minimum) || hasValue(maximum)) && e.target.value) {
        //     const val = parseInt(e.target.value);
        //     if (hasValue(minimum) && val < minimum) {
        //         return;
        //     }
        //     if (hasValue(maximum) && val > maximum) {
        //         return;
        //     }
        // }
        onChange(e);
    }, [noNegative, onChange]);

    return (
        <SMCTextInput
            className={className}
            disabled={disabled}
            readOnly={readOnly}
            value={displayValue}
            onChange={_onChange}
            noAutoComplete={noAutoComplete}
            style={style}
            width={width}
            type="number"
            placeholder={placeholder}
            allowClearAll={allowClearAll}
            height={height}
            inline={inline}
            label={label}
            labelPosition={labelPosition}
            labelWidth={labelWidth}
            suffixIcon={suffixIcon}
            suffixIconOnClick={suffixIconOnClick}
            tooltip={tooltip}
            innerRef={innerRef}
            required={required}
            ignoreDisabledContext={ignoreDisabledContext}
            {...rest}
        />
    );
}

SMCNumberInput.propTypes = {
    disabled: PropTypes.bool,
    readOnly: PropTypes.bool,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onChange: PropTypes.func,
    className: PropTypes.string,
    label: PropTypes.node,
    labelPosition: PropTypes.oneOf(['start', 'end']),
    labelWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    tooltip: PropTypes.node,
    inline: PropTypes.bool,
    noAutoComplete: PropTypes.bool,
    style: PropTypes.object,
    placeholder: PropTypes.string,
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    innerRef: PropTypes.any,
    allowClearAll: PropTypes.bool,
    suffixIcon: PropTypes.string,
    suffixIconOnClick: PropTypes.func,
    required: PropTypes.bool,
    ignoreDisabledContext: PropTypes.bool,
    noNegative: PropTypes.bool
}

export default React.memo(SMCNumberInput);